<template>
  <div class="widget widget-info">
    <div class="widget-info-bg">
      <img
        v-if="settings.value.show_avatar_block || true"
        src="/img/man_min.png"
        alt=""
      >
      <div class="widget-content">
        <p v-html="settings.value.show_content_block"></p>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";

export default {
  mixins: [widgetHelper],
  computed: {
    ...mapGetters(["streams"]),
  },
  data() {
    return {
      reviews: [],
    };
  },
  mounted() {},
};
</script>

<style lang="scss">
.widget-info {
  padding-bottom: 12px;
}
.widget-info-bg {
  height: 100%;
  widows: 100%;
  display: flex;
  border-radius: 5px;
  background: #349ef1;
  color: #fff;
  flex-direction: row;
  padding: 20px;
  img {
    width: 25%;
    max-width: 256px;
    object-fit: contain;
    margin: 0 20px auto 0;
  }
  .widget-content {
    flex-wrap: wrap;
    max-height: 100%;
    padding-bottom: 0;
  }
  p {
    margin: 0;
  }
}
</style>
